export const environment = {
    BUILD_PRODUCT: "admin",
    API_URL_BASE: "https://api.12082026.xyz/",
    API_LOGIN_URL: "v1/users/login",
    API_USER_SELF: "v1/users/self",
    PRODUCT_URLS: {
        LANDING_PAGE: "https://12082026.xyz",
        USER_APP: "https://app.12082026.xyz",
        RESTAURANT: "https://restaurant.12082026.xyz",
        DRIVER: "https://driver.12082026.xyz",
        ADMIN: "https://admin.12082026.xyz",
        ACCOUNT: "https://account.12082026.xyz"
    },
    API_VERIFICATION_APPROVE: "v1/admin/restaurants/{restaurantId}/accept-verification",
    API_VERIFICATION_DECLINE: "v1/admin/restaurants/{restaurantId}/decline-verification",
    API_RESTAURANTS_SEARCH: "v1/admin/restaurants",
    API_USERS_SEARCH: "v1/admin/users",
    DEBUG_STAGING_BADGE: true
};
